import "./App.css";
import { useState, useEffect } from "react";
import MainRouter from "./V1/routes";
import "react-datepicker/dist/react-datepicker.css";
import "react-sliding-pane/dist/react-sliding-pane.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton/dist/skeleton.css'
import { getToken, update_token } from "./V1/auth/SSO";
import axiosAPI from "./V1/utils/axios-api";

// import {initializeApp} from "firebase/app";
// import { getTokenSM, onMessageListener } from "./firebase";

axiosAPI.interceptors.response.use(
  (successRes) => {
    return successRes;
  },
  (error) => {
    if (error.response?.status === 405) {
    return getToken(error);
    }
  }
);

function App() {
  const [isTokenFound, setTokenFound] = useState(false);
  const [show, setShow] = useState(false);

  // console.log(`Aaaah
  // Help me find my way
  // I said help me find my way
  // No force inside of me
  // Stone cold lips and help me see
  // All lies into a degree
  // Losing you I wanna be
  // You'll find out I do
  // He maybe out of his mind
  // But some day you will find
  // That sanity's left us all blind
  // And dragged us all behind
  // Of moment's seemed to go's eyes
  // Crystal blue disguise
  // They say that all beauty must die
  // I say it just moves on
  // If you'd only open your mind
  // Then someday you will find
  // Insanity's left us behind
  // And walked right through the night
  // I can see the picture's clear
  // As yesterday pictures of my own
  // I can hear the voice's begging you to stay
  // But know you're not alone`)

  useEffect(() => {

    // getTokenSM(setTokenFound);
    // onMessageListener()
    //   .then((message) => {
    //     // setShow(true);
    //     alert("Berhasil");
    //   })
    //   .catch((err) => console.log("failed: ", err));
      
  }, []);
  // console.log(
  //   "%cStop! Jangan lupa pake masker - darkfox an indonesian developer",
  //   "background-color: red; font-size: 20px"
  // );
  return <MainRouter />;
}

export default App;